import { createRouter, createWebHistory } from "vue-router";

import LoginView from "@/views/LoginView.vue";
import DashboardView from "@/views/DashboardView.vue";
import ApplicationView from "@/views/applications/ApplicationView.vue";
import CustomersView from "@/views/customers/CustomersView.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
  },
  {
    path: "/applications",
    name: "applications",
    component: ApplicationView,
  },
  {
    path: "/customers",
    name: "customers",
    component: CustomersView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
